import { Spaceoq5xo9lsieqc as Space } from '../direct/Space.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BlankClass;
function Blank() {
  if (BlankClass === VOID) {
    class $ {
      ndk(viewWriter, data, index) {
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Space())(viewWriter.pc());
        var tmp0_elvis_lhs = viewWriter.ebb_1;
        var p = tmp0_elvis_lhs == null ? viewWriter : tmp0_elvis_lhs;
        viewWriter.gbb(p, view);
        viewWriter.hbb(p, view);
        return view;
      }
      pdg(viewWriter, data, index) {
        return this.ndk(viewWriter, data, index);
      }
    }
    initMetadataForObject($, 'Blank');
    BlankClass = $;
  }
  return BlankClass;
}
var Blank_instance;
function Blank_getInstance() {
  return Blank_instance;
}
//region block: init
Blank_instance = new (Blank())();
//endregion
//region block: exports
export {
  Blank_instance as Blank_instance9t9guv2wakl7,
};
//endregion

//# sourceMappingURL=RecyclerViewRenderer.mjs.map
